import { LitElement } from 'lit'
import { customElement } from 'lit/decorators.js'

import { injectLegacyLightDomStyles } from '../common/light-dom-styles.js'
import style from './FieldContent.css'

/**
 * Field Content wraps a [Field Label](/components/field-label/) and
 * [Field Description](/components/field-description/) so they stay aligned as a
 * single text block, which is especially useful in horizontal
 * [Field](/components/field/) layouts.
 *
 * @status draft
 * @category form
 * @lightDom true
 *
 * @slot - Default slot for the label and description.
 */
@customElement('nord-field-content')
export default class FieldContent extends LitElement {
  connectedCallback() {
    super.connectedCallback()
    injectLegacyLightDomStyles(this, style)
  }

  protected createRenderRoot() {
    return this
  }
}

declare global {
  interface HTMLElementTagNameMap {
    'nord-field-content': FieldContent
  }
}
